import { render, staticRenderFns } from "./PrivacyPolicy.vue?vue&type=template&id=92a58be0&scoped=true&"
import script from "./PrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./PrivacyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyPolicy.vue?vue&type=style&index=0&id=92a58be0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92a58be0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92a58be0')) {
      api.createRecord('92a58be0', component.options)
    } else {
      api.reload('92a58be0', component.options)
    }
    module.hot.accept("./PrivacyPolicy.vue?vue&type=template&id=92a58be0&scoped=true&", function () {
      api.rerender('92a58be0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PrivacyPolicy.vue"
export default component.exports